import cloneDeep from 'lodash/cloneDeep';
import { ETAT_BROUILLON } from '@/configuration/devisConf';
import { SOUS_TYPE_AVOIR } from '@/configuration/facture/factureConf';
import gestionDateBase from '@/services/general/gestionDateBase';

export default function genererAvoirFactureBailleur(factureBailleur, date, commentaire) {
  const avoir = cloneDeep(factureBailleur);
  avoir.sousType = SOUS_TYPE_AVOIR;
  avoir.referenceId = factureBailleur.id;
  avoir.id = null;
  avoir.lignesCommande.forEach(l => {
    delete l.id;
    l.quantite = 0;
    l.lignesCommande.forEach(sousL => {
      delete sousL.id;
      sousL.quantite = 0;
    });
  });
  avoir.dateDevisCommande = date || new Date();
  avoir.etat = ETAT_BROUILLON;
  avoir.code = null;
  avoir.commentaireInterne = commentaire;
  avoir.echeancierPaiement.forEach(ech => {
    ech.dateEcheance = gestionDateBase(ech.dateEcheance);
  });
  return avoir;
}
